"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BadRequest = void 0;
const ApiException_1 = require("./ApiException");
class BadRequest extends ApiException_1.ApiException {
    constructor(message = 'Bad Request', data) {
        super(message, data);
    }
}
exports.BadRequest = BadRequest;
